import { PROFILE_STATE } from '@profile/app/constants/state.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const PROFILE_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${PROFILE_STATE.PROJECT}.**`,
  url: '/profile',
  loadChildren: () => import('@profile/app/profile.module').then((m) => m.ProfileModule),
};

export const APP_STATES = [PROFILE_MODULE_STATE];
